import { useTranslation } from 'react-i18next'

import { FormModal } from '../../Form'
import { getValidationSchemaEditFinalDocTitle } from '../DocFlow.utils'
import { DocFlowEditFinalDocumentFields } from '../DocFlowEditFinalDocumentFields'

function DocFlowEditFinalDocumentModal({
  fieldName,
  getPayload,
  initialValues,
  profileAction,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const validationSchema = getValidationSchemaEditFinalDocTitle({
    fieldName,
    initialValues,
    t,
  })

  return (
    <FormModal
      Fields={DocFlowEditFinalDocumentFields}
      formBodyProps={{
        withNotifications: true,
      }}
      formFieldsProps={{
        profileAction,
        titleFieldName: fieldName,
      }}
      formTitle='DocumentStapling.ModalEditFinalDocumentTitleKey'
      getPayload={getPayload}
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}

export default DocFlowEditFinalDocumentModal
